import { Typography } from "antd";
import PropTypes from "prop-types";

const { Text } = Typography;

const TextEllipsis = ({ children }) => {
  return <Text ellipsis={{ tooltip: children }}>{children}</Text>;
};

TextEllipsis.propTypes = {
  children: PropTypes.node,
};

export default TextEllipsis;
